import React from "react";
// import { withRouter } from "react-router";
import AssignmentDashboard from "../AssignmentMainDashboard/AssignmentMainDashboard";
import { getClassInfo } from "../../../../utils/authentication-access";

const AssessmentWebViewList = (props) => {
  return (
    <>
      <AssignmentDashboard
        classname={getClassInfo().name}
        {...props}
        webViewActivated={true}
      />
    </>
  );
};

export default AssessmentWebViewList;
